import styled from 'styled-components'
import { AdvantagesElement } from 'Pages/landings/newLandings/common/components'
import { WrapperBlock, gridFour } from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled(WrapperBlock)`
	${gridFour}
	grid-template-columns: 1fr;
	grid-template-rows: auto auto auto;
`
export const Element = styled(AdvantagesElement)`
	margin-bottom: 0px;
`
